import request from './request';
import deserialize from './deserialize';

export type LoyaltyProgram = {
  id: string;
  announcementRateLimit: number;
  createdAt: number;
  joiningDescription: string;
  lastAnnouncementDate: number;
  lastLoyaltyCampaignDate: number;
  loyaltyCampaignRateLimitDays: number;
  maxStampCampaigns: number;
  memberAuthOptions: string;
  menuUnlockPin: string;
  qrMainTitle: string;
  qrRegenCodeInterval: number;
  qrSubTitle: string;
  referralCode: string;
  showStorePin: boolean;
  stampRateLimit: number;
  updatedAt: number;
  weMissYouCreated: boolean;
};

export function get(merchantId: string) {
  return request<LoyaltyProgram>({
    url: `/api/v3/merchants/${merchantId}/loyalty_program`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
